import React from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

ContentData.propTypes = {
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  dataField: PropTypes.string,
};

function ContentData({component, dataField, contextPath, ...props}) {
  const item = useSelector((state) => state.Content.data?.[props.path]);
  const eventIdList = useSelector((state) => {
    return !!contextPath &&state.Content.activity?.[contextPath]?.eventsByItem?.[props.path];
  });

  if (!item) {
    return null;
  }

  return React.createElement(component, {
    ...props,
    eventIdList,
    [dataField || "data"]: item,
  });
}

export default ContentData;
